export const valueTagData = [
  {
    valueTagId: 1,
    name: "Customer First",
    description: "Demonstrates effort to understand, satisfy, and retain customers.",
    iconCode: "lni lni-handshake",
  },
  {
    valueTagId: 2,
    name: "Discipline",
    description: "Shows consistency in attendance, punctuality, and execution.",
    iconCode: "lni lni-checkmark",
  },
  {
    valueTagId: 3,
    name: "Teamwork",
    description: "Supports colleagues, shares knowledge, and helps build team synergy.",
    iconCode: "lni lni-users",
  },
  {
    valueTagId: 4,
    name: "Initiative",
    description: "Takes proactive steps without waiting to be told.",
    iconCode: "lni lni-rocket",
  },
  {
    valueTagId: 5,
    name: "Accountability",
    description: "Owns responsibilities and follows through on commitments.",
    iconCode: "lni lni-clipboard",
  },
  {
    valueTagId: 6,
    name: "Kaizen Spirit",
    description: "Continuously looks for improvements in work, process, or product.",
    iconCode: "lni lni-gear",
  },
  {
    valueTagId: 7,
    name: "Result-Oriented",
    description: "Focuses on achieving measurable outcomes, not just activities.",
    iconCode: "lni lni-graph",
  },
  {
    valueTagId: 8,
    name: "Learning Mindset",
    description: "Seeks feedback, self-learns, and grows professionally.",
    iconCode: "lni lni-book",
  },
  {
    valueTagId: 9,
    name: "Respect",
    description: "Treats others with dignity regardless of hierarchy or disagreement.",
    iconCode: "lni lni-user",
  },
  {
    valueTagId: 10,
    name: "Cost Conscious",
    description: "Acts with awareness of budget, resources, and business sustainability.",
    iconCode: "lni lni-calculator", // only if exists in your icon set
  },
  {
    valueTagId: 11,
    name: "Ownership Mentality",
    description: "Thinks and acts like a stakeholder of the business.",
    iconCode: "lni lni-badge",
  },
  {
    valueTagId: 12,
    name: "Strategic Thinking",
    description: "Considers long-term impact, not just short-term execution.",
    iconCode: "lni lni-brain",
  },
  {
    valueTagId: 13,
    name: "Transparency",
    description: "Shares information openly, avoids hidden agendas.",
    iconCode: "lni lni-eye",
  },
  {
    valueTagId: 14,
    name: "Problem Solving",
    description: "Responds to issues with solution-focused thinking.",
    iconCode: "lni lni-lightbulb",
  },
  {
    valueTagId: 15,
    name: "Agility",
    description: "Adapts to change quickly and with a positive attitude.",
    iconCode: "lni lni-arrow-up",
  },
  {
    valueTagId: 16,
    name: "Innovation",
    description: "Generates or contributes to new ideas, methods, or improvements.",
    iconCode: "lni lni-rocket",
  },
  {
    valueTagId: 17,
    name: "Quality Focus",
    description: "Delivers work with attention to detail and standards.",
    iconCode: "lni lni-checkmark",
  },
  {
    valueTagId: 18,
    name: "Safety Compliance",
    description: "Upholds safety rules, legal requirements, and policies.",
    iconCode: "lni lni-shield",
  },
  {
    valueTagId: 19,
    name: "Mentorship",
    description: "Guides or develops others to improve their performance.",
    iconCode: "lni lni-users",
  },
  {
    valueTagId: 20,
    name: "Positivity",
    description: "Brings optimism and encourages morale in the workplace.",
    iconCode: "lni lni-smile",
  },
];
